import { Vertical } from "@/components/standard/BFLayout"
import FullScreenBackground from "@/components/backgrounds/FullScreenBackgroundGradient"
import { BFButton } from "@/components/buttons/CommonButtons"
import { useState } from "react"
import { useSafeAreaInsets } from "react-native-safe-area-context"

export default function ThemeTest() {
  const [selected, setSelected] = useState(false)
  const insets = useSafeAreaInsets()
  return (
    <Vertical className="flex-1" style={{ marginTop: insets.top }}>
      <Vertical className="flex-1 relative bg-midnight-blue gap-4">
        <FullScreenBackground />
        <Vertical className={"p-4 gap-4"}>
          <BFButton
            selected={selected}
            onPress={() => {
              setSelected(!selected)
            }}
            title={"Primary Dark Button (toggles selection)"}
            testID={"test-button-primary=dark"}
            variant={"primaryDark"}
          />
          <BFButton
            selected={selected}
            title={"Disabled Button"}
            disabled={true}
            testID={"test-button-primary=dark"}
            variant={"primaryDark"}
          />
          <BFButton
            selected={selected}
            title={"Secondary Dark Button"}
            testID={"test-button-primary=dark"}
            variant={"secondaryDark"}
          />

          <BFButton
            selected={selected}
            title={"Medium Button"}
            testID={"test-button-primary=dark"}
            variant={"primaryDark"}
            size={"md"}
          />

          <BFButton
            selected={selected}
            title={"Small Button"}
            testID={"test-button-primary=dark"}
            variant={"primaryDark"}
            size={"sm"}
          />

          {/* <BFButton */}
          {/*  title={"Test Button"} */}
          {/*  testID={"test-button-primary=dark"} */}
          {/*  variant={"teal"} */}
          {/* /> */}

          {/* <Pressable */}
          {/*  className={cn( */}
          {/*    "relative rounded-full border-1", */}
          {/*    "bg-calm-blue hover:bg-[#1B5A7F] active:bg-[#144460] w-full p-4 rounded-full" */}
          {/*  )} */}
          {/* > */}
          {/*  <Horizontal className={"gap-2 justify-center items-center"}> */}
          {/*    <H5 className="text-teal text-center flex-row">Button Play</H5> */}
          {/*    <SubSelectedIcon width={16} height={16} /> */}
          {/*  </Horizontal> */}
          {/* </Pressable> */}
        </Vertical>
      </Vertical>
      <Vertical className="flex-1 relative bg-off-white p-4 gap-4">
        {/* <Pressable */}
        {/*  className={cn( */}
        {/*    "relative rounded-full", */}
        {/*    "bg-off-white border border-midnight-blue hover:bg-[#EEF1F4] active:bg-[#D3D5D8] w-full p-2 rounded-full" */}
        {/*  )} */}
        {/* > */}
        {/*  <Horizontal className={"gap-2 justify-center items-center"}> */}
        {/*    <H6 className="text-midnight-blue leading-[14px] text-center flex-row"> */}
        {/*      Button Play */}
        {/*    </H6> */}
        {/*    /!* <SubSelectedIcon width={16} height={16} /> *!/ */}
        {/*  </Horizontal> */}
        {/* </Pressable> */}

        <BFButton
          selected={selected}
          title={"Primary Button"}
          testID={"test-button-primary=dark"}
          variant={"primary"}
        />

        <BFButton
          selected={selected}
          title={"Secondary Button"}
          testID={"test-button-primary=dark"}
          variant={"secondary"}
        />

        <BFButton
          selected={selected}
          title={"Secondary Button sm"}
          size={"sm"}
          testID={"test-button-primary=dark"}
          variant={"secondary"}
        />

        <BFButton
          selected={selected}
          title={"Disabled Button"}
          disabled={true}
          testID={"test-button-primary=dark"}
          variant={"secondary"}
        />

        <BFButton
          loading={true}
          title={"Loading Button lg"}
          testID={"test-button-primary=dark"}
          variant={"primary"}
          size={"lg"}
        />

        <BFButton
          loading={true}
          title={"Loading Button sm"}
          testID={"test-button-primary=dark"}
          variant={"primaryDark"}
          size={"sm"}
        />
      </Vertical>
    </Vertical>
  )
}
